<template>
    <div>
        <div class="motion" v-if="onShow">
            <p @click="onMotion">X</p>
            <div class="image">
                <img src="~assets/image/motionGraph.gif" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            onShow: ""
        }
    },
    mounted(){
        this.onShow = window.sessionStorage.getItem('montionShow')?false:true;
    },
    methods:{
        onMotion(){
            this.onShow = false;
            window.sessionStorage.setItem('montionShow',this.onShow);
        }
    }

}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1200px) {
    .motion {
        display: none;
    }
}

.motion {
    position: relative;
    width: 130px;
    height: 150px;
    // border: 1px solid #CCC;
    position: fixed;
    right: -1%;
    bottom: 10%;

    p {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #ddd;
        position: absolute;
        right: 25px;
        top: -10px;
        text-align: center;
        line-height: 20px;
        color: #ddd;
        cursor: pointer;
        display: none;
        transition: all 5s;

    }
    &:hover p {
        display: block;
    }

    .image {
        img {
            width: 130px;
        }
    }
}
</style>